"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _ProductImgListItem = _interopRequireDefault(require("@sprinx/react-com/ProductImgListItem"));

var _ProductImgListWithTitle = _interopRequireDefault(require("../ProductImgListWithTitle"));

var _ProductListItemWrapper = _interopRequireDefault(require("./ProductListItemWrapper"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _div;

  return {
    root: {},
    headline: (0, _defineProperty2.default)({
      flexDirection: 'column'
    }, theme.breakpoints.up('sm'), {
      flexDirection: 'row'
    }),
    arrows: {
      display: 'flex',
      '& > button': {
        padding: theme.spacing(1),
        '& > span > svg': {
          width: 36,
          height: 36
        }
      }
    },
    listItem: {
      '& > div': (_div = {}, (0, _defineProperty2.default)(_div, theme.breakpoints.up('xs'), {
        minWidth: '50%',
        flexBasis: '50%'
      }), (0, _defineProperty2.default)(_div, theme.breakpoints.up('md'), {
        minWidth: '33.33%',
        flexBasis: '33.33%'
      }), (0, _defineProperty2.default)(_div, theme.breakpoints.up('lg'), {
        minWidth: '25%',
        flexBasis: '25%'
      }), _div)
    }
  };
}, {
  name: 'SxProductImgList'
});

function ProductImgList(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      currency = _ref.currency,
      _ref$ProductListItemC = _ref.ProductListItemComponent,
      ProductListItemComponent = _ref$ProductListItemC === void 0 ? _ProductListItemWrapper.default : _ref$ProductListItemC,
      products = _ref.products,
      title = _ref.title,
      TitleComponent = _ref.TitleComponent,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "currency", "ProductListItemComponent", "products", "title", "TitleComponent"]);
  var classes = useStyles({
    classes: pClasses
  });
  var theme = (0, _styles.useTheme)();
  var tablets = (0, _useMediaQuery.default)(theme.breakpoints.up('md'));
  var desktop = (0, _useMediaQuery.default)(theme.breakpoints.up('lg'));
  var cardCount = desktop ? 4 : tablets ? 3 : 2; // eslint-disable-line no-nested-ternary

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_ProductImgListWithTitle.default, {
    title: title,
    cardCount: cardCount,
    TitleComponent: TitleComponent,
    classes: {
      content: classes.listItem,
      headline: classes.headline,
      arrows: classes.arrows,
      title: classes.title
    }
  }, products.map(function (i, index) {
    return /*#__PURE__*/_react.default.createElement(_ProductImgListItem.default, {
      product: i,
      currency: currency,
      key: index.toString(),
      ProductListItemComponent: ProductListItemComponent
    });
  })));
}

process.env.NODE_ENV !== "production" ? ProductImgList.propTypes = {
  classes: _propTypes.default.shape({
    arrows: _propTypes.default.string,
    headline: _propTypes.default.string,
    listItem: _propTypes.default.string,
    root: _propTypes.default.string,
    title: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string,
  ProductListItemComponent: _propTypes.default.elementType,
  products: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  title: _propTypes.default.node,
  TitleComponent: _propTypes.default.node
} : void 0;
ProductImgList.defaultProps = {
  classes: undefined,
  className: undefined,
  currency: undefined,
  ProductListItemComponent: undefined,
  title: undefined,
  TitleComponent: undefined
};
var _default = ProductImgList;
exports.default = _default;